module.exports = __webpack_public_path__ + "static/img/product-page-banner.4a1be0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-page-banner.png
// module id = 8Iw/
// module chunks = 0